import { styled } from '@mui/material/styles';

const StyledNotFound = styled('div')`
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 2rem;

  & > div {
    width: fit-content;
    align-items: center;
  }

  & h1 {
    width: fit-content;
    text-align: center;
  }

  & p {
    text-align: center;
    color: var(--step-description-color);
  }
`;

export default StyledNotFound;
